import React from 'react';

import { Separator } from '@epoch-ui/components/Separator';
import { useEditableEvent } from '@event-editor/hooks/useEditableEvent';
import useFeatureFlag from 'hooks/useFeatureFlag';
import { DATABRICKS_LIMITED_SLACK_PERMS } from 'constants/featureFlags';

import { CalendarSettingsSection } from './sections/CalendarSettingsSection';
import { SlackChannelSettingsSection } from './sections/SlackChannelSettingsSection';
import { ReportingSettingsSection } from './sections/ReportingSettingsSection';
import { DuplicateEventSection } from './sections/DuplicateEventSection';
import { CancelEventSection } from './sections/CancelEventSection';
import { DeleteDraftEventSection } from './sections/DeleteDraftEventSection';

export const EditEventSettings = (): React.ReactElement => {
  const event = useEditableEvent();
  const isCancelled = !!event.scheduledDeletionAt;
  const isDatabricksLimitedSlackPerms = useFeatureFlag(DATABRICKS_LIMITED_SLACK_PERMS);

  return (
    <div className="tw-space-y-10">
      <CalendarSettingsSection />
      <Separator className="tw-my-8" />
      {!isDatabricksLimitedSlackPerms && <SlackChannelSettingsSection />}
      {!isDatabricksLimitedSlackPerms && <Separator className="tw-my-8" />}
      <ReportingSettingsSection />
      <Separator className="tw-my-8" />
      <DuplicateEventSection />
      <Separator className="tw-my-8" />
      {event.isPublished || isCancelled ? <CancelEventSection /> : <DeleteDraftEventSection />}
    </div>
  );
};
